module.exports = {
  entry: './src/apps/world-map-table/index.tsx',
  shortcode: 'world-map-table',
  title: 'World Map Data Table',
  status: 'stable',
  description:
    'The World Map Table widget is a support component for the World Map Leadspace and presents its content in a table format',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-world-map-table-components-worldmaptable--default`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
  },
};
